// console.log('Header drawer contents goes here');



class HeaderDrawer extends HTMLElement {
    constructor() {
        super();

        this.HeaderDrawer = this;
        this.HeaderDrawerToggle = this.querySelector('.header-drawer-toggle');
        this.HeaderDrawerDetails = this.querySelector('.header-drawer-details');
        this.subMenuItemIcons = this.querySelectorAll('.header-drawer-main-menu-item-icon');
        this.subMenuItemToggles = this.querySelectorAll('.header-drawer-main-menu-subitems-panel__title');

        this.focusTrap = new MettaFocusTrap(this, {
            onEscape: () => this.close()
        });

        this.HeaderDrawerToggle.addEventListener('click', (event) => this.onClick(event))


        document.addEventListener('click', (event) => {
            const headerDrawer = this.HeaderDrawer;
            if (event.target !== headerDrawer && !headerDrawer.contains(event.target)) {
                this.close()
            }
        })


        for(let subMenuItemIcon of this.subMenuItemIcons ){
            subMenuItemIcon.addEventListener('click', () => this.subMenuClick(subMenuItemIcon))
        }

        for(let subMenuItemToggle of this.subMenuItemToggles){
            subMenuItemToggle.addEventListener('click', () => this.subMenuToggleClick(subMenuItemToggle))
        }
    }

    onClick(event) {
        event.preventDefault();

        if( this.classList.contains('active') ){
            this.close();
        }
        else{
            this.open()
        }
    }

    open() {
        if( this.HeaderDrawer.classList.contains('active') ) return;
        this.HeaderDrawerDetails.classList.add('visible');
        this.HeaderDrawerToggle.setAttribute('aria-expanded', 'true');

        setTimeout(() => {
            this.HeaderDrawer.classList.add('active');
            this.focusTrap.activate({ opener: this.HeaderDrawerToggle });
        }, 50);
    }
    close() {
        if( !this.HeaderDrawer.classList.contains('active') ) return;
        this.focusTrap.deactivate();
        this.HeaderDrawer.classList.remove('active');
        this.HeaderDrawerToggle.setAttribute('aria-expanded', 'false');

        setTimeout(() => {
            this.HeaderDrawerDetails.classList.remove('visible');
        }, 300);
    }

    subMenuClick(subMenuItemIcon){

        const subMenuItem = subMenuItemIcon.parentNode.parentNode;
        
        this.HeaderDrawerDetails.classList.add('inactive');
        subMenuItem.classList.contains('active') ? subMenuItem.classList.remove('active') : subMenuItem.classList.add('active')
    }

    subMenuToggleClick(subMenuItemIcon){
        
        const subMenuItem = subMenuItemIcon.parentNode.parentNode;
        
        this.HeaderDrawerDetails.classList.remove('inactive');
        subMenuItem.classList.remove('active')
    }

}

customElements.define('header-drawer', HeaderDrawer);